import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import AuthCheck from '../components/auth/AuthCheck';
import routes from '../config/routes';
import MainLayout from './MainLayout';

function LayoutSelector() {
  const location = useLocation();
  const currentRoute = routes.find((route) => matchPath(location.pathname, { path: route.path, exact: true }));
  const Layout = currentRoute?.layout ?? MainLayout;
  const publicRoute = currentRoute?.publicRoute ?? false;
  const permission = currentRoute?.permission ?? null;
  const redirectTo = currentRoute?.redirectTo ?? null;

  return (
    <AuthCheck publicRoute={publicRoute} permission={permission} redirectTo={redirectTo}>
      <Layout />
    </AuthCheck>
  );
}

export default LayoutSelector;
